// TODO: rename to more general name
export enum IncentiveRecordsWorkflowTemplateTypeEnum {
  EmployeeMail = 'EmployeeMail',
  ManagerMail = 'ManagerMail',
  EmployeeTask = 'EmployeeTask',
  ManagerTask = 'ManagerTask',
  BusinessPartnerMail = 'BusinessPartnerMail',
  ManagerPromotionMail = 'ManagerPromotionMail',
  CompanyManagerMail = 'CompanyManagerMail',
  ECLMail = 'ECLMail',
  GlobalEquityTeamMail = 'GlobalEquityTeamMail'
}
